import { defineComponent as _defineComponent } from 'vue'
import TileItem from '@/components/SideBar/Tiles/TileItem.vue';
import { ExpansionKey, NodeRunErrorDialogKey, TileContextMenuFunctionsKey, WorkflowsKey } from '@/components/SideBar/types';
import { ExperienceWorkflowWithContext, UIElement } from '@ply-io/ply-front-shared-utilities';
import { computed, provide } from 'vue';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

export default /*#__PURE__*/_defineComponent({
  __name: 'TileElementTreeBlockButton',
  props: {
    element: null,
    workflow: null
  },
  setup(__props: any) {

const props = __props as { element: UIElement; workflow: ExperienceWorkflowWithContext }


// dummy provides
provide(WorkflowsKey, {
	getMappedFields: () => ({}),
	createWorkflow: async () => {},
	runWorkflow: async () => {},
	startCreateTile: () => {},
	styleEditingWorkflowId: computed(() => null),
	clearStyleEditingWorkflowId: () => {},
});
provide(TileContextMenuFunctionsKey, {
	deleteWorkflow: async () => {},
	editWorkflow: async () => {},
	editButtonStyle: async () => {},
	openEditSetup: async () => {},
	openShareWorkflow: async () => {},
	setIsVisible: () => {},
});
provide(NodeRunErrorDialogKey, {
	clearNodeRunErrorDialog: () => {},
	nodeRunErrorDialogState: computed(() => null),
	setNodeRunErrorDialogState: () => {},
});
provide(ExpansionKey, {
	clearExpansion: () => {},
	expandedContext: computed(() => null),
	expandedTile: computed(() => null),
	expandTile: () => {},
});
const tileTitle = computed(() =>
	isObject(props.element.metadata.injectionStyle) &&
	'text' in props.element.metadata.injectionStyle &&
	isObject(props.element.metadata.injectionStyle.text) &&
	'value' in props.element.metadata.injectionStyle.text &&
	isString(props.element.metadata.injectionStyle.text.value)
		? props.element.metadata.injectionStyle.text.value
		: ''
);

return { __sfc: true,props, tileTitle, TileItem }
}

})